// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    actual_billing: 'Facturable réel',
    actual_cost: 'Coût réel',
    ActualBillableExpenses: 'Dépenses facturables réelles',
    ActualBillableExpensesShort: 'Dépenses facturables réelles',
    ActualBilledShort: 'Facturé réel',
    ActualBillingShort: 'Facturable réel',
    ActualBudgetProfitability: 'Performance budgétaire réelle',
    ActualCost: 'Coût réel',
    ActualCostQtip: 'Coût réel = Coût de la main-d\'œuvre réelle + Dépenses réelles',
    ActualExpenses: 'Dépenses réelles',
    ActualExpensesListTitle: 'Réel',
    ActualExpensesShort: 'Dépenses réelles',
    ActualHours: 'Heures réelles',
    ActualLaborBilling: 'Main-d\'œuvre facturable réelle',
    ActualLaborBillingShort: 'Main-d\'œuvre facturable réelle',
    ActualLaborCost: 'Coût de la main-d\'œuvre réelle',
    ActualLaborCostShort: 'Coût de la main-d\'œuvre réelle',
    add_activities_flat_fees: 'ajouter des frais forfaitaires d\'activités',
    add_as_actual_expense: 'Ajouter comme dépense réelle',
    add_planned_billable_expenses: 'ajouter des dépenses facturables planifiées',
    add_received_payment: 'Ajouter un paiement reçu',
    add_scheduled_payment: 'Ajouter un paiement programmé',
    AddActivitiesBudgets: 'ajouter des budgets d\'activités',
    AddBudgetLabel: 'Ajouter un budget pour ce projet',
    AddPlannedExpenses: 'ajouter des dépenses planifiées',
    Amount: 'Montant',
    approver_label: 'Approbateur',
    approvers_problem_warning: 'Un des approbateurs ne peut plus approuver les dépenses. Mettez à jour la liste des approbateurs.',
    ApproveTooltip: 'Transfère les dépenses planifiées en dépenses réelles',
    back_to_metrics: 'Retour aux métriques',
    batch_actual_text: 'Ajouter comme dépenses réelles',
    batch_approval_text: 'Approuver les dépenses',
    batch_billed_text: 'Marquer comme facturé',
    batch_operation_failed_description: 'L\'opération n\'a pas pu être effectuée pour cette dépense. Cela peut être dû à sa suppression ou à un manque d\'autorisations pour effectuer des opérations avec celle-ci. Consultez votre administrateur {brandName} pour connaître les causes possibles.',
    batch_operations_failed_description: 'L\'opération n\'a pas pu être effectuée pour {0} des {1} dépenses. Cela peut être dû à leur suppression ou à un manque d\'autorisations pour effectuer des opérations avec celles-ci. Consultez votre administrateur {brandName} pour connaître les causes possibles.',
    batch_reject_text: 'Rejeter les dépenses',
    Billable: 'Facturable',
    Billed: 'Facturé',
    BilledPercentQtip: 'Facturé = (Main-d\'œuvre facturée + Dépenses facturées) / Facturable EAC * 100%',
    BilledVsActualCost: 'Facturé vs Coût réel',
    Billing: 'Facturable',
    Billing_Info_Title: 'Informations de facturation',
    billing_type_item_readonly: 'La modification n\'est pas disponible dans la grille lorsque le type de facturation est « Tarif ». Vous pouvez le modifier dans la section Finances.',
    BillingHelp: 'Dans la section Facturation, vous pouvez choisir le type de facturation approprié pour votre projet et définir un tarif, tel qu\'un tarif horaire, ou un montant fixe pour un projet à forfait.',
    BillingSettings: 'Paramètres de facturation',
    BillingSettingsTitle: 'Facturation',
    BillingType: 'Type de facturation',
    BillingTypeLabel: 'Calculer par ',
    BillingUtilization: 'Utilisation de la facturation anticipée',
    BudgetedCost: 'Budget total du projet',
    BudgetHelp: 'Dans cette section, vous pouvez consulter le budget total du projet, composé de celui de toutes ses activités, et définir un budget au niveau du projet.',
    CancelTooltip: 'Annuler',
    chart_actual_billing: 'Facturable réel',
    chart_actual_cost: 'Coût réel',
    chart_billable_expenses: 'Dépenses facturables',
    chart_billed: 'Facturé',
    chart_billed_expenses: 'Dépenses facturées',
    chart_eac_billing: 'Facturable EAC',
    chart_expenses: 'Dépenses',
    chart_non_billable_expenses: 'Dépenses non facturables',
    chart_payments: 'Paiements reçus',
    chart_scheduled_payments: 'Paiements programmés',
    ContingencyPadding: 'Marge de contingence',
    Cost: 'Coût total',
    CPI: 'CPI',
    CurrencyLabel: 'Devise',
    CustomerHourlyRateLabel: 'Tarif horaire client',
    Date: 'Date',
    delete_the_expense_title: 'Supprimer la dépense',
    delete_the_payment_title: 'Supprimer le paiement',
    DeletePaymentConfirmation: 'Êtes-vous sûr de vouloir supprimer cet enregistrement ?',
    DeleteTooltip: 'Supprimer',
    Description: 'Description',
    DetailedReportTitleTemplate: 'Rapport détaillé pour {0}',
    EAC: 'Estimation à l\'achèvement',
    eac_billing: 'Facturable à l’achèvement (EAC)',
    eac_cost: 'Coût à l’achèvement (EAC)',
    EACBilling: 'Facturable EAC',
    EACBillingLong: 'Facturable à l’achèvement (EAC)',
    EACBillingQtip: 'Facturable à l’achèvement (EAC) = Facturable réel + Facturable ETC',
    EACBillingQtipInfo: 'Montant total facturable estimé incluant la main-d\'œuvre facturable et les dépenses facturables (Réel + Estimation à réaliser (ETC))',
    EACCost: 'Coût à l’achèvement (EAC)',
    EACCost_short: 'Coût EAC',
    EACCostQtip: 'Coût à l’achèvement (EAC) = Coût réel + Coût ETC',
    EnteredBy: 'Saisi par',
    EstimatedBudgetProfitability: 'Rentabilité budgétaire estimée',
    EstimatedCostVariance: 'Écart de coût estimé',
    EstimatedExpenses: 'Dépenses estimées',
    EstimatedHours: 'Heures estimées',
    EstimatedProfit: 'Profit attendu',
    EstimatedProfitPercentQtip: 'Profit attendu (%) = (Facturable EAC - Coût EAC) / Facturable EAC * 100%',
    EstimatedProfitQtip: 'Profit attendu = Facturable EAC - Coût EAC',
    etc_billing: 'Facturable à réaliser (ETC)',
    etc_cost: 'Coût à réaliser (ETC)',
    ETCBillableExpenses: 'Dépenses facturables ETC',
    ETCBillableExpensesShort: 'Dépenses facturables ETC',
    ETCBilling: 'Facturable ETC',
    ETCBillingShort: 'Facturable ETC',
    ETCCost: 'Coût ETC',
    ETCCostShort: 'Coût ETC',
    ETCCosttQtip: 'Coût à réaliser (ETC) = Coût de main-d\'œuvre ETC + Dépenses ETC',
    ETCExpenses: 'Dépenses ETC',
    ETCExpensesShort: 'Dépenses ETC',
    ETCLaborBilling: 'Main-d\'œuvre facturable ETC',
    ETCLaborBillingShort: 'Main-d\'œuvre facturable ETC',
    ETCLaborCost: 'Coût de main-d\'œuvre ETC',
    ETCLaborCostShort: 'Coût de main-d\'œuvre ETC',
    ExpectedRevenue: 'Revenu attendu',
    expenses: '1#{0} dépense#{0} dépenses',
    expenses_approval_info: 'Active l\'approbation des dépenses pour l\'ensemble du projet et toutes ses activités.',
    expenses_approval_label: 'Approbation des dépenses',
    expenses_approval_remove_all_approvers_title: 'Supprime tous les approbateurs, ce qui désactive le processus d\'approbation des dépenses après l\'enregistrement.',
    expenses_approval_status_approved: 'Approuvé',
    expenses_approval_status_none: 'En attente d\'approbation',
    expenses_approval_status_rejected: 'Rejeté',
    expenses_approved_successfully_plural: '1#La dépense a été approuvée#{0} dépenses ont été approuvées',
    expenses_rejected_successfully_plural: '1#La dépense a été rejetée#{0} dépenses ont été rejetées',
    expenses_updated_successfully_plural: '1#La dépense a été mise à jour avec succès.#{0} dépenses ont été mises à jour avec succès.',
    FeeAmount: 'Montant des honoraires',
    FlatFee: 'Forfait',
    GeneralInfo: 'Informations générales',
    HourlyRate: 'Taux horaire',
    InternalBudget: 'Budget',
    InternalEstimatedCost: 'Coût estimé',
    LaborBilling: 'Main-d\'œuvre facturable',
    LaborCost: 'Coût de main-d\'œuvre',
    legend_actual: 'Réel',
    legend_estimated_at_completion: 'Estimation à l’achèvement',
    log_actual_expense: 'Saisir la dépense réelle',
    log_expenses: 'Saisir des dépenses',
    log_payments: 'Saisir des paiements',
    log_planned_expense: 'Saisir la dépense planifiée',
    money_for_date_label: '{0} pour {1} ?',
    no_targets: 'Aucun objectif à afficher',
    NoActualExpenses: 'Il n\'y a pas de dépenses.',
    None: 'Aucun',
    NoneCurrency: 'Choisir la devise',
    NoPayments: 'Il n\'y a pas de paiements.',
    NoPlannedExpenses: 'Il n\'y a pas de dépenses planifiées.',
    NotBillable: 'Non facturable',
    NotBillableLabel: 'Non facturable',
    NotBilled: 'Non facturé',
    OpenRateCard: 'Ouvrir la grille tarifaire',
    OutstandingPaymentBalance: 'Solde des paiements en attente',
    PaymentDescriptionWatermark: 'Description...',
    PaymentReceived: 'Paiement reçu',
    payments_total: '1#{0} paiement#{0} paiements',
    PaymentsOfSchedPayments: 'Paiements des paiements planifiés',
    PercentageBilled: 'Pourcentage facturé',
    PercentageProjectBilled: 'Pourcentage facturé',
    Percentages: 'Pourcentage',
    PlannedExpenses: 'Dépenses planifiées',
    PlannedExpensesListTitle: 'Planifiées',
    ppFormat: '{0}pp',
    Profit: 'Profit',
    ProfitQtip: 'Profit = Facturable réel - Coût réel',
    Project_no_rateCard_for_rateCard_billingType: 'Vous devez spécifier une grille tarifaire si la facturation du projet est basée sur la grille tarifaire.',
    ProjectActivityName: 'Nom du projet / de l’activité',
    ProjectBilling: 'Facturation du projet',
    ProjectBillingIsBasedOn: 'La facturation du projet est basée sur',
    ProjectBillingUtilization: 'Utilisation de la facturation',
    ProjectBudget: 'Budget main-d\'œuvre',
    ProjectCost: 'Coût interne du projet',
    ProjectCostVariance: 'Écart de coût du projet',
    ProjectEarnedValue: 'Valeur acquise du projet',
    ProjectEarnedValueInfo: 'Représente la santé du projet',
    ProjectExpectedRevenue: 'Revenu attendu du projet',
    ProjectFixedCostLabel: 'Forfait du projet',
    ProjectHourlyRateLabel: 'Taux horaire du projet',
    ProjectPayments: 'Paiements du projet',
    ProjectPlannedExpenses: 'Dépenses planifiées du projet',
    ProjectPlannedExpensesInfo: 'Dépenses planifiées pour un projet spécifique et dépenses planifiées agrégées à partir de ses activités',
    ProjectProfit: 'Profit du projet',
    ProjectProfitability: 'Rentabilité du projet',
    ProjectProfitabilityInfo: 'Représente le pourcentage de valeur créée par projet',
    ProjectTimeUsage: 'Utilisation du temps du projet',
    ProjectTimeUsageInfo: 'Affiche combien du temps budgété a été utilisé, en pourcentage des heures estimées',
    ProjectWorkInProgress: 'Travaux en cours du projet',
    PymentsVsActualCost: 'Paiements vs Coût réel',
    RateCardLabel: 'Grille tarifaire',
    Receipt: 'Reçu',
    Received: 'Reçu',
    ReceivedPaymentsListTitle: 'Reçus',
    RemainingInternalBudget: 'Budget restant',
    RemainingInternalBudgetQtip: 'Budget restant = Budget - Coût réel',
    RemainingInternalBudgetQtipForProject: 'Budget restant = Budget total - Coût réel',
    ResourceHourlyRateLabel: 'Taux horaire de la ressource',
    Revenue: 'Revenu',
    revert_approval_text: 'Modifier cette dépense réinitialisera son statut à En attente d\'approbation et relancera le processus d\'approbation depuis le début. Toute approbation ou tout rejet précédent sera perdu. Voulez-vous continuer ?',
    revert_approval_title: 'Rétablir la dépense pour réapprobation ?',
    Scheduled: 'Planifié',
    ScheduledPaymentsListTitle: 'Planifiés',
    set_targets: 'Définissez les objectifs à l’aide de',
    Settings: 'Paramètres',
    ShowAll: 'TOUT AFFICHER',
    ShowBreakdown: 'Afficher la ventilation',
    ShowFull: 'AFFICHER TOUT',
    SPI: 'SPI',
    status_label: 'Statut',
    tab_Actual: 'Dépenses réelles',
    tab_expenses: 'Dépenses',
    tab_overview: 'Aperçu',
    tab_payments: 'Paiements',
    tab_Planned: 'Dépenses planifiées',
    tab_Received: 'Paiements reçus',
    tab_Scheduled: 'Paiements planifiés',
    tab_targets: 'Objectifs',
    TargetBudget: 'Budget total',
    TargetLaborRevenue: 'Revenu cible main-d\'œuvre',
    TargetProfit: 'Profit cible',
    TargetRevenue: 'Revenu cible',
    Targets: 'Objectifs',
    targets_tab: 'Onglet objectifs',
    TargetsEACBilling: 'Facturable EAC',
    TaskRateLabel: 'Taux de l’activité',
    TimeAndMaterial: 'Temps & matériel',
    TimeUsage: 'Utilisation du temps',
    TitleText: 'Finances',
    total_billable: 'Total facturable',
    TotalBilled: 'Total facturé',
    TotalProjectBudget: 'Budget total du projet',
    TotalProjectPayments: 'Total des paiements du projet',
    TotalProjectPaymentsInfo: 'Résumé de tous les paiements effectués par tous les clients',
    TotalTargetRevenue: 'Revenu cible total',
    TrackProfitAs: 'Suivre le profit comme',
    Validation_DateMandatory: 'La date est un champ obligatoire.',
    Validation_InvalidAmount: 'Le montant doit être un nombre positif.',
    Validation_InvalidDate: 'La date doit être au format \'{0}\'.',
    Validation_Range: 'La valeur ne se situe pas dans la plage attendue.',
    Variance: 'Écart',
    warning_currency: 'La devise est prise à partir de la grille tarifaire choisie',
    WorkInProgress: 'Travail en cours',
};
